var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsIdCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.71509 12.1514C10.8661 12.1514 11.7151 11.3024 11.7151 10.1514C11.7151 9.00037 10.8661 8.15137 9.71509 8.15137C8.56409 8.15137 7.71509 9.00037 7.71509 10.1514C7.71509 11.3024 8.56309 12.1514 9.71509 12.1514Z",
    fill: "#656565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0257 4.65137H4.02525C3.0465 4.65137 2.25 5.39162 2.25 6.30137V18.5511C2.25 19.4609 3.0465 20.2004 4.02525 20.2004H20.025C21.0037 20.2004 21.7995 19.4609 21.7995 18.5511V6.30137C21.8002 5.39162 21.0037 4.65137 20.0257 4.65137ZM20.25 18.6516L3.80025 18.6411V6.20162L20.25 6.21287V18.6516Z",
    fill: "#656565"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.15137H18V11.1514H14V9.15137ZM15 13.1514H18V15.1514H15V13.1514ZM13.43 15.6874C13.43 14.3134 11.754 12.9014 9.715 12.9014C7.676 12.9014 6 14.3134 6 15.6874V16.1514H13.43V15.6874Z",
    fill: "#656565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsIdCard);
export default __webpack_public_path__ + "static/media/icons-id-card.19dc7a9cd222e856f78a7df1576d41fd.svg";
export { ForwardRef as ReactComponent };